<template>
    <div class="col-md-3 mb-sm-3 mb-md-0">
        <b-list-group
            role="tablist"
            class="shadow bg-white h-100 p-b rounded-0"
        >
            <b-list-group-item
                @click="
                    page = 'home';
                    $emit('page', page);
                "
                :class="page == 'home' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Detalhe do Acolhimento
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'primeira';
                    $emit('page', page);
                "
                :class="page == 'primeira' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Primeira Observação
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'caracteristica';
                    $emit('page', page);
                "
                :class="page == 'caracteristica' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Características
            </b-list-group-item>
            <b-list-group-item
                @click="page = 'objetivo_idoso'; $emit('page', page)"
                :class="page == 'objetivo_idoso' ? 'active' : ''" 
                class="nav-link"
                href="#" 
                role="tab"
            >
                Objetivos e Metas
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'atividade'; 
                    $emit('page', page);
                "
                :class="page == 'atividade' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Atividades
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'encaminhamentos';
                    $emit('page', page);
                "
                :class="page == 'encaminhamentos' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Encaminhamentos
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'termo';
                    $emit('page', page);
                "
                :class="page == 'termo' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Termo de Compromisso
            </b-list-group-item>

            <b-list-group-item
                @click="
                    page = 'pia';
                    $emit('page', page);
                "
                :class="page == 'pia' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Plano Individual de Atendimento - PIA
            </b-list-group-item>

            <b-list-group-item
                @click="
                    page = 'historicopia';
                    $emit('page', page);
                "
                :class="page == 'historicopia' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Histórico PIA
            </b-list-group-item>
            
            <b-list-group-item v-if="acolhimento.familiares_na_unidade == 1 || acolhimento.outros_familia_acolhimento == 1"
                @click="
                    page = 'paf';
                    $emit('page', page);
                "
                :class="page == 'paf' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Plano de Atendimento Familiar - PAF
            </b-list-group-item>

        </b-list-group>
    </div>
</template>
<script>
export default {
    props: ["active", "acolhimento"],
    data() {
        return { page: "home" };
    },
    mounted() {
        if (this.active) {
            this.page = this.active;
        }
    },
    methods: {},
    computed: {
        idade() {
            if (!this.acolhimento?.nascimento) return 0;
            const nascimento = new Date(this.acolhimento.nascimento);
            const hoje = new Date();
            let idade = hoje.getFullYear() - nascimento.getFullYear();
            const m = hoje.getMonth() - nascimento.getMonth();
            if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
                idade--;
            }
            return idade;
        },
    },
};
</script>
